export const staffData = [
  //{
  //  id: 501,
  //  first_name: "Nahom",
  //  middle_name: "Getachew",
  //  last_name: "Alemu",
  //  email: "na@gmail.com",
  //  phone_no: "+251978634512",
  //  status: { id: 1, name: "part time" },
  //  rank: { id: 1, name: "Msc" },
  //  position: { id: "1", name: "president" },
  //  office: { id: "office1", name: "Electrical Department" },
  //  qualification: "networking",
  //  start_date: "2014-12-12",
  //  end_date: "",
  //  load: 7,
  //},
  //{
  //  id: 502,
  //  first_name: "Koy",
  //  middle_name: "Getachew",
  //  last_name: "Alemu",
  //  email: "nuna@gmail.com",
  //  status: { id: 1, name: "part time" },
  //  rank: { id: 1, name: "Msc" },
  //  position: { id: "1", name: "president" },
  //  office: { id: "office1", name: "Electrical Department" },
  //  phone_no: "+251978634512",
  //  qualification: "networking",
  //  department: { id: "office1", name: "Electrical Department" },
  //  start_date: "2014-12-12",
  //  end_date: "",
  //  load: 7,
  //},
];
